import { useState } from "react";
import DaftarAbsen from "./DaftarAbsen";
import { useLocation } from "react-router-dom";
import AbsenBulananContain from "./AbsenBulananContain";
import AbsenTahunanContain from "./AbsenTahunanContain";
import AbsenListContain from "./AbsenListContain";

const AbsenContain = () => {
  const { search } = useLocation();
  const parameters = new URLSearchParams(search);
  const type = parameters.get("type");

  const [isPNS, setIsPNS] = useState(false);

  const toggleIsPNS = () => {
    setIsPNS(!isPNS);
  };

  return (
    <DaftarAbsen selectedComponent={type} toggle={toggleIsPNS} isPNS={isPNS}>
      {type === "bulanan" ? (
        <AbsenBulananContain />
      ) : type === "tahunan" ? (
        <AbsenTahunanContain />
      ) : (
        <AbsenListContain isPNS={isPNS} toggleIsPNS={toggleIsPNS} />
      )}
    </DaftarAbsen>
  );
};

export default AbsenContain;
